/* ============================================================
   USWE V2 Product & Collection Card Logic
   (Hover Preview + Variant Redirect on Click)
   ============================================================ */

function initUSWESwatchLogic() {
  const cards = document.querySelectorAll(".product-card, .collection-product-card");
  if (!cards.length) return;

  cards.forEach((card) => {
    const mainImage = card.querySelector(".product-image");
    const mainLink = card.querySelector(".card-media");
    const swatches = card.querySelectorAll(".uswe-card__color-images a");
    if (!mainImage || !mainLink || !swatches.length) return;

    const originalSrc = mainImage.src;
    const originalHref = mainLink.href;
    let selectedVariantUrl = originalHref;

    swatches.forEach((swatch) => {
      const img = swatch.querySelector(".uswe-color-variant-image");
      const variantUrl = img?.dataset.variantUrl || swatch.getAttribute("href");
      const previewSrc = img?.dataset.large || img?.src;

      // 🖱️ Desktop hover (just preview)
      swatch.addEventListener("mouseenter", () => {
        if (window.innerWidth > 768 && previewSrc) {
          mainImage.src = previewSrc;
          mainLink.href = variantUrl;
        }
      });

      swatch.addEventListener("mouseleave", () => {
        if (window.innerWidth > 768) {
          mainImage.src = originalSrc;
          mainLink.href = selectedVariantUrl;
        }
      });

      // 👆 Click / tap (select variant)
      swatch.addEventListener("click", (e) => {
        e.preventDefault();

        // Highlight the selected swatch
        card
          .querySelectorAll(".uswe-color-variant-image")
          .forEach((i) => i.classList.remove("active"));
        img.classList.add("active");

        // Update main image + link
        if (previewSrc) mainImage.src = previewSrc;
        selectedVariantUrl = variantUrl;
        mainLink.href = variantUrl;

        // Desktop: open directly
        if (window.innerWidth > 768) {
          window.location.href = variantUrl;
        }
      });
    });

    // 📱 Mobile: click main image → open selected color
    mainLink.addEventListener("click", (e) => {
      if (window.innerWidth <= 768 && selectedVariantUrl) {
        e.preventDefault();
        window.location.href = selectedVariantUrl;
      }
    });
  });

  console.log(`🟢 Swatch logic active on ${cards.length} product cards`);
}

/* ============================================================
   Tooltip logic (unchanged)
   ============================================================ */
function initUSWETooltips() {
  if (document.getElementById("hydration-tooltip")) return;

  const tooltip = document.createElement("div");
  tooltip.id = "hydration-tooltip";
  Object.assign(tooltip.style, {
    position: "absolute",
    background: "rgba(0,0,0,0.85)",
    color: "#fff",
    fontSize: "12px",
    padding: "4px 8px",
    borderRadius: "4px",
    pointerEvents: "none",
    opacity: "0",
    transition: "opacity 0.2s ease, transform 0.2s ease",
    zIndex: "9999",
    whiteSpace: "nowrap",
    maxWidth: "200px",
    textAlign: "center",
  });
  document.body.appendChild(tooltip);

  const icons = document.querySelectorAll(".hydration-included-icon, .hydration-compatible-icon");
  icons.forEach((icon) => {
    icon.addEventListener("mouseenter", () => {
      const text = icon.dataset.tooltip || "";
      tooltip.textContent = text;
      tooltip.style.opacity = "1";

      requestAnimationFrame(() => {
        const rect = icon.getBoundingClientRect();
        const tipRect = tooltip.getBoundingClientRect();
        const gap = 6;
        let top = window.scrollY + rect.top - tipRect.height - gap;
        let left = window.scrollX + rect.left + rect.width / 2 - tipRect.width / 2;

        if (left < 4) left = 4;
        if (left + tipRect.width > window.innerWidth - 4)
          left = window.innerWidth - tipRect.width - 4;
        if (top < window.scrollY) top = window.scrollY + rect.bottom + gap;

        tooltip.style.top = `${top}px`;
        tooltip.style.left = `${left}px`;
      });
    });

    icon.addEventListener("mouseleave", () => (tooltip.style.opacity = "0"));

    icon.addEventListener("touchstart", () => {
      const text = icon.dataset.tooltip || "";
      tooltip.textContent = text;
      tooltip.style.opacity = "1";

      const rect = icon.getBoundingClientRect();
      tooltip.style.top = `${window.scrollY + rect.bottom + 6}px`;
      tooltip.style.left = `${window.scrollX + rect.left + rect.width / 2}px`;
      tooltip.style.transform = "translateX(-50%)";

      setTimeout(() => (tooltip.style.opacity = "0"), 1500);
    });
  });

  console.log(`💧 Tooltip active on ${icons.length} hydration icons`);
}

/* ============================================================
   Mobile swatch height adjustment
   ============================================================ */
function adjustSwatchHeightMobile() {
  if (window.innerWidth <= 768) {
    document.querySelectorAll(".uswe-card__color-images").forEach((container) => {
      const swatches = container.querySelectorAll(".uswe-color-variant-image");
      swatches.forEach((img) => {
        img.style.height = swatches.length >= 4 ? "34px" : "45px";
        img.style.width = swatches.length >= 4 ? "34px"  : "45px";
      });
    });
  }
}

/* ============================================================
   Run all scripts
   ============================================================ */
function runUSWECardScripts() {
  initUSWESwatchLogic();
  initUSWETooltips();
  adjustSwatchHeightMobile();
}

document.addEventListener("DOMContentLoaded", runUSWECardScripts);
document.addEventListener("shopify:section:load", runUSWECardScripts);
document.addEventListener("shopify:section:reorder", runUSWECardScripts);
document.addEventListener("ajaxContentReplaced", runUSWECardScripts);

console.log("✅ uswe-v2-product-card.js loaded");
